export default "__VITE_ASSET__D_7E6u2m__"